import PropTypes from "prop-types";

export const SIZES = ["xs", "sm", "md", "lg", "xl", "full"];

export const COLOR_ROLES = [
  "primary",
  "secondary",
  "tertiary",
  "error",
  "success",
  "primary-container",
  "secondary-container",
  "tertiary-container",
  "surface",
  "default",
  "variant",
  "inherit",
];

export const STATUS_ROLES = [
  "unavailable",
  "vaulted",
  "pending",
  "critical",
  "success",
  "featured",
  "vip",
  "info",
];

const fail = (message) => {
  throw new Error(message);
};

export const subsetOf = (vocabulary) => (values) => {
  const unknown = values.filter((value) => !vocabulary.includes(value));
  return unknown.length === 0
    ? values
    : fail(
        `${unknown.join(", ")} not in the vocabulary: ${vocabulary.join(", ")}`,
      );
};

export const sizeOf = (...sizes) => PropTypes.oneOf(subsetOf(SIZES)(sizes));

export const colorOf = (...colors) =>
  PropTypes.oneOf(subsetOf(COLOR_ROLES)(colors));

export const statusOf = (...statuses) =>
  PropTypes.oneOf(subsetOf(STATUS_ROLES)(statuses));
